import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaProperty } from "../Schema";
import { EntityNames } from "../../../../enums/EntityNames";
import SidePanelDisposalsView from "../../layout/SidePanel/layouts/SidePanelDisposalsView";

export const DisposalChecksSchema: ISchema = {
    displayName: "Disposal Checks",
    GetSidePanelComponent: (data, onViewPage) => <SidePanelDisposalsView data={data} onViewPage={onViewPage} />,
    onAdd: (id: string) => window.location.assign(`/view/${EntityNames.disposals}/${id}`),
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'operatorId',
            displayName: 'Checked By',
            type: PropertyTypes.selectByEntityName,
            entityName: EntityNames.operators,
            key: false,
            showInList: false,
            showInForm: true,
            showInView: false,
            requiredInForm: true,
            className: "small-12",
        } as ISchemaProperty,
    ],
};
